@for (annotation of callToAction().annotations; track annotation) {
	<vlaio-product-annotation [annotation]="annotation" />
}

@switch (callToAction().action) {
	<!-- Login -->

	@case (ButtonActionTypes.Login) {
		<vlaio-event-button
			buttonType="NeutralOutline"
			vlaioUserEIDLogin
			cypressTag="Offers.Product.Login"
			icon="fa-chalkboard-user"
			layout="spread"
			[productId]="product().id"
			[title]="callToAction().name"
			[fullWidth]="true"
		>
			{{ callToAction().name }}
		</vlaio-event-button>
	}

	<!-- Request access eloket -->

	@case (ButtonActionTypes.RequestAccessEloket) {
		@if (routePath().type === 'internal') {
			<vlaio-internal-button
				buttonType="Action"
				icon="fa-key"
				layout="spread"
				[title]="callToAction().name"
				[fullWidth]="true"
				[link]="routePath().path"
				(handleClick)="handleEloRequestClicked()"
			>
				{{ callToAction().name }}
			</vlaio-internal-button>
		} @else {
			<vlaio-external-button
				buttonType="Action"
				icon="fa-key"
				layout="spread"
				[title]="callToAction().name"
				[fullWidth]="true"
				[link]="routePath().path"
				(handleClick)="trackCtaClicked.emit()"
			>
				{{ callToAction().name }}
			</vlaio-external-button>
		}
	}

	<!-- Request access -->

	@case (ButtonActionTypes.RequestAccess) {
		<vlaio-external-button
			buttonType="Action"
			icon="fa-key"
			layout="spread"
			[title]="callToAction().name"
			[fullWidth]="true"
			[link]="callToAction().link"
			(handleClick)="trackCtaClicked.emit()"
		>
			{{ callToAction().name }}
		</vlaio-external-button>
	}

	<!-- More info -->

	@case (ButtonActionTypes.MoreInfo) {
		<vlaio-external-button
			buttonType="Neutral"
			icon="fa-up-right-from-square"
			layout="spread"
			[title]="callToAction().name"
			[fullWidth]="true"
			[link]="callToAction().link"
			(handleClick)="trackCtaClicked.emit()"
		>
			{{ callToAction().name }}
		</vlaio-external-button>
	}

	<!-- Fallback (Start case) -->

	@default {
		<vlaio-external-button
			buttonType="Regular"
			icon="fa-up-right-from-square"
			layout="spread"
			[title]="callToAction().name"
			[fullWidth]="true"
			[link]="callToAction().link"
			(handleClick)="trackCtaClicked.emit()"
		>
			{{ callToAction().name }}
		</vlaio-external-button>
	}
}
